module.exports = __webpack_public_path__ + "static/6305-woodrose-35-4d4e5bbea7a93cbf89b141931c330f17.jpg";